var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let AppStylesheets = class AppStylesheets extends React.PureComponent {
    render() {
        const { app } = this.props;
        // su: stage units
        // au: animation units
        // ai: animation intensity factor
        return (React.createElement("style", { dangerouslySetInnerHTML: {
                __html: `
    :root {
        --su: ${app.stage.draftLayout.stageUnitInPixel}px;
        --au: ${app.stage.draftLayout.stageUnitInPixel}px;
        --ai: 1
       } `
            } }));
    }
};
AppStylesheets = __decorate([
    observer
], AppStylesheets);
export { AppStylesheets };
